import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { chatAction } from "../../../../store/actions/ChatActions";
import Chat from "./Chat";
import { msgAction } from "../../../../store/actions/MsgAction";

function ChatScreen(props) {
	const dispatch = useDispatch();

	const chat = useSelector((state) => state.chat);

	return (
		<div className={`chatbox ${chat ? "active" : ""}`}>
			<div
				className="chatbox-close"
				onClick={() => {
					dispatch(msgAction(false));
					dispatch(chatAction(false));
				}}
			></div>

			<div className="custom-tab-1">
				<ul className="d-flex justify-content-center align-items-center nav nav-tabs">
					<li className="nav-item">
						<Link className="nav-link active" to="#" data-toggle="tab" onClick={() => {}}>
							Chat
						</Link>
					</li>
				</ul>

				<div className="tab-content">
					<Chat
						sendMessage={props.sendMessage}
						lastMessage={props.lastMessage}
						readyState={props.readyState}
					/>
				</div>
			</div>
		</div>
	);
}

export default ChatScreen;
